export default function CustomButtonConfirm({
    loading = false,
    textLoad = 'Processing',
    text,
    handleOnClick,
    className = '',
    ...props
}) {
    return (
        <div className="flex w-full py-1">
            <button
                type="submit"
                disabled={loading}
                aria-busy={loading}
                aria-disabled={loading}
                onClick={!loading ? handleOnClick : undefined}
                className={`
                    flex w-full items-center justify-center gap-2
                    h-12 rounded-md font-normal text-base
                    transition-colors duration-200
                    ${loading
                        ? 'bg-cs-border text-cs-muted cursor-not-allowed'
                        : 'bg-cs-primary text-white hover:bg-cs-primary-hover'
                    }
                    ${className}
                `}
                {...props}
            >
                {loading ? (
                    <>
                        <svg
                            className="animate-spin h-5 w-5"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                        >
                            <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                            />
                            <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0
                                   C5.373 0 0 5.373 0 12h4zm2
                                   5.291A7.962 7.962 0 014 12H0
                                   c0 3.042 1.135 5.824 3 7.938
                                   l3-2.647z"
                            />
                        </svg>
                        <span>{textLoad}...</span>
                    </>
                ) : (
                    text
                )}
            </button>
        </div>
    );
}
